/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_My_Integrations_NoneInputs */



/**
* | output |
* | --- |
* | "You don't have access to any integrations yet." |
*
* @param {Connections_My_Integrations_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_my_integrations_none = /** @type {((inputs?: Connections_My_Integrations_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_My_Integrations_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben noch keinen Zugriff auf Integrationen.")
	return /** @type {LocalizedString} */ ("You don't have access to any integrations yet.")
});